<script lang="ts">
    import type { Vehicle } from './Vehicle';
    import IconTruck from '../../shared/Icons/IconTruck.svelte';
    import IconCar from '../../shared/Icons/IconCar.svelte';
    import TemplateIcon from '../../shared/Icons/TemplateIcon.svelte';
    import { PointOnMap } from '../Planning/VehiclesOnMap/PointOnMap';
    import IconVehicle from '../../shared/Icons/IconVehicle.svelte';
    import IconTruck2 from '../../shared/Icons/IconTruck2.svelte';

    export let vehicle: Vehicle;
    export let scale: number = 1;
    export let displayMode: 'pin' | 'icon' | 'none' = 'icon';

    let src = PointOnMap.getIconUrl(
        vehicle.getColor() ?? '#0000FF',
        1,
        40,
        60,
        vehicle.isTruck() ? 'truck' : 'car',
        false,
        false
    );
</script>

{#if displayMode === 'pin'}
    <div style="margin:-10px;">
        <TemplateIcon {src} scale={1.7} />
    </div>
{:else if displayMode === 'icon'}
    {#if vehicle.isTruck()}
        <IconTruck {scale} />
    {:else}
        <IconCar {scale} />
    {/if}
{/if}
